import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { ACTION_STATUS } from "constants/actions";
import { ACTION_VIEW_MODE } from "constants/action-form";
import Title from "../../../Typography/Title";
import DetailSection from "../DetailSection";
import DateSpan from "../date-span/DateSpan";
import QuantityInput from "../../../action-inputs/quantity/QuantityInput";
import useAvailableQuantityUnits from "../../utils/useAvailableOperationUnits";
import { EquipmentUsed } from "../equipment";
import ActionModalDescriptionSection from "../description/ActionModalDescriptionSection";
import BioSelectionInput from "components/action-inputs/bio-selection/BioSelectionInput";
import FertilizerInput from "components/action-inputs/fertilizer/FertilizerInput";
import FertilizeLimits from "./Limits";

const FertilizePerformed = ({ viewMode, isFullWidth, fertilizers, isNewVersion }) => {
  const { t } = useTranslation();

  const { values } = useFormikContext();
  const status = ACTION_STATUS.performed;
  const isViewMode = viewMode === ACTION_VIEW_MODE.view;

  const { availableQuantityUnits } = useAvailableQuantityUnits(
    values.taskId,
    values.fertilizeAction?.operationTypeId,
  );

  return (
    <div className="action-modal-card action-details-box ">
      <div className={isFullWidth && "details-half-width"}>
        <Title title={t("ActionModal.Details.Performed")} />
        {!isNewVersion && <DateSpan viewMode={viewMode} status={status} />}
        <DetailSection
          title={t("ActionModal.Fertilizer")}
          isRequired={!isViewMode}
          isNewVersion={isNewVersion}
        >
          <div className="action-details-column-multiple">
            <BioSelectionInput task="fertilize" isViewMode={isViewMode} />

            <FertilizerInput
              fertilizers={fertilizers}
              isViewMode={isViewMode}
            />
          </div>
        </DetailSection>
        <DetailSection
          title={t("ActionModal.Quantity")}
          isRequired={!isViewMode}
          isNewVersion={isNewVersion}
        >
          <QuantityInput
            task="fertilize"
            isViewMode={isViewMode}
            quantityOptions={availableQuantityUnits}
          />
          <FertilizeLimits fertilizers={fertilizers} />
        </DetailSection>
        <EquipmentUsed isInEditMode={viewMode !== ACTION_VIEW_MODE.view} />
        <ActionModalDescriptionSection
          task="fertilize"
          isViewMode={isViewMode}
          isNewVersion={isNewVersion}
        />
      </div>
    </div>
  );
};

export default FertilizePerformed;
